import React, { Component } from 'react'
import { List, ActionSheet, TextareaItem, Toast, Modal } from 'antd-mobile'
import './index.less'
import RefundTips from './components/refund-tips'
import RefundType from './components/refund-type'
import { fetchOrderRefund } from '../../api/order-refund'
import { setHeader } from '@/util/set-header'
const Alert = Modal.alert

// 退货类型
enum OrderRefundType {
  undefined = '请选择',
  typeOne = '商品破损',
  typeTwo = '多拍/错拍',
  typeThree = '下错门店',
  typeFour = '缺货',
}

export default class OrderRefund extends Component<any, any> {
  state: any = {
    type: OrderRefundType.undefined,
    brief: '',
  }

  UNSAFE_componentWillMount() {
    setHeader({ title: '申请售后', right: <span className="nav-right" onClick={this._submit}>提交申请</span> })
  }

  _refundTypeClick = () => {
    const BUTTONS = [
      OrderRefundType.typeOne,
      OrderRefundType.typeTwo,
      OrderRefundType.typeThree,
      OrderRefundType.typeFour,
      '取消',
    ]
    ActionSheet.showActionSheetWithOptions(
      {
        options: BUTTONS,
        cancelButtonIndex: BUTTONS.length - 1,
        // title: 'title',
        message: '请选择一个退款原因',
        maskClosable: true,
      },
      buttonIndex => {
        if (buttonIndex < BUTTONS.length - 1) {
          this.setState({
            type: BUTTONS[buttonIndex],
          })
        }
      },
    )
  }

  _submit = async () => {
    const { type, brief } = this.state
    let order_sn = this.props.location.state.order_sn
    if (type === OrderRefundType.undefined) {
      Toast.info('请先选择申请原因', 1)
      return
    }

    let result = await fetchOrderRefund({
      order_sn: order_sn,
      remark: brief,
      type: type,
    })
    let baseModel = result.data
    if (baseModel) {
      if (baseModel.code === 'SUCCESS') {
        Alert('提示', '申请退货成功', [
          {
            text: '确定',
            onPress: () => {
              this.props.history.push(`/order-list/0`)
            },
            style: 'default',
          },
        ])
      } else {
        Toast.info(baseModel.msg, 1)
      }
    } else {
      Toast.info("服务器格式错误", 1)
    }
  }

  _inputChange = (value: any) => {
    this.setState({
      brief: value,
    })
  }

  _handleBlur() {
    window.scroll(0, 0);
  }

  render() {
    return (
      <div>
        <div className="nav-space" />
        <List>
          <RefundTips title="仅支持整单退款" brief="你可以重新下单喜欢的商品" />
          <RefundType type={this.state.type} onClick={this._refundTypeClick} />
          <TextareaItem
            placeholder="请详细描述问题情况"
            rows={7}
            labelNumber={5}
            onChange={this._inputChange}
            onBlur={this._handleBlur}
          />
        </List>
      </div>
    )
  }
}
